<a routerLink="/artist/{{artist.id}}">
  <div class="card h-100">
    <img class="card-img-top" [src]="getArtistImg(artist.id)" alt="{{artist.name}}">
    <div class="card-body">
      <h5 class="card-title" data-ta-name="artistName">{{artist.name}}</h5>
      <p class="card-text text-muted">{{artist.getLabelForAlbumCount()}}</p>
    </div>
  </div>
</a>
